import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import './index.css';

interface BreadCrumbsProps {
  hasSubMenus?: boolean;
  customNameMap?: Record<string, string>;
  disabledCrumbs?: string[];
}

const BreadCrumbs = ({ hasSubMenus, customNameMap = {}, disabledCrumbs = [] }: BreadCrumbsProps) => {
    const location = useLocation();
    const params = useParams();
    let currentLink: string[] = [];
    
    // Get all param values to check against
    const paramValues = Object.values(params);
    
    const crumbs = location.pathname.split('/')
        .filter(crumb => crumb !== '')
        .map((crumb, index) => {
            currentLink.push(`/${crumb}`);
            const isFirstCrumbWithSubmenus = index === 0 && hasSubMenus;
            const isThirdCrumbWithSubmenus = index === 2 && hasSubMenus;
            const isCurrentPath = currentLink.join('') === location.pathname;
            const isDisabledCrumb = disabledCrumbs.includes(crumb);

            // Check if this crumb should be replaced with custom name
            const shouldUseCustomName = customNameMap[crumb] !== undefined;
            
            if (shouldUseCustomName) {
                return (
                    <div className='crumb' key={crumb}>
                        <span className="no-underline">
                            {customNameMap[crumb]}
                        </span>
                    </div>
                );
            }

            // Skip displaying raw IDs in breadcrumbs (check against all param values)
            if (paramValues.includes(crumb)) {
                return null;
            }

            const displayCrumb = decodeURIComponent(crumb.replace(/-/g, ' '))
                .charAt(0).toUpperCase() + decodeURIComponent(crumb.replace(/-/g, ' ')).slice(1);

            return (
                <div className='crumb' key={crumb}>
                    {isFirstCrumbWithSubmenus || isThirdCrumbWithSubmenus || isCurrentPath || isDisabledCrumb ? (
                        <span className="no-underline">
                            {displayCrumb}
                        </span>
                    ) : (
                        <Link to={currentLink.join('')} className="no-underline">
                            {displayCrumb}
                        </Link>
                    )}
                </div>
            );
        })
        .filter(Boolean); // Remove null entries

    return (
        <div className='breadeCrumbs'>
            {crumbs}
        </div>
    );
};

export default BreadCrumbs;